import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FieldPositioningCompletePage } from './field-positioning-complete';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    FieldPositioningCompletePage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(FieldPositioningCompletePage),
  ],
})
export class FieldPositioningCompletePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/field-positioning/field-positioning-complete/field-positioning-complete.module.ts